<template>
  <div class="container page lottery">
    <van-nav-bar :title="taskTitle" class="nav-bar">
      <!-- <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template> -->
         <template #right>
           <div class="task-switcher-btn" @click="showRight" :title="$t('reservation.switching_window')">
             <van-icon name="apps-o" color="#fff" />
           </div>
       </template>
    </van-nav-bar>
    <div class="record">
      <div class="period">
        <van-image class="cover" round :src="userAvatar" fit="cover">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
          <template v-slot:error>
            <img src="/img/mine/avatar.png" style="width:100%;height:100%;object-fit:cover;" />
          </template>
        </van-image>
        <span class="period-number">{{ lottery.now_expect }} {{ $t('reservation.num') }}</span>
        <div class="next-number">
          <!-- <span>{{this.lottery.next_expect}}</span> -->
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>
      <div
        class="linear-gradient"
        style="
          background: linear-gradient(
            to right,
            rgba(126, 86, 120, 0),
            rgb(230, 195, 161),
            rgba(126, 86, 120, 0)
          );
        "
      ></div>
      <div class="numberBox result-box">
        <div class="result-box__label">
          <div class="result-box__expect">{{ displayExpect || '--' }}</div>
          <div class="result-box__heading">{{ $t('reservation.voting_results') }}</div>
        </div>
        <div class="resBox">
          <div class="resItem">{{ hasResult ? displaySum : '--' }}</div>
          <div class="pills">
            <div class="ressquareBox" :class="{ empty: !hasResult }">{{ hasResult ? displaySize : '—' }}</div>
            <div class="ressquareBox" :class="{ empty: !hasResult }">{{ hasResult ? displayDouble : '—' }}</div>
          </div>
          <van-icon name="arrow-down" :class="{ up: active, down: !active }" @click="active = !active" class="result-box__toggle" />
        </div>
      </div>

    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
        
          <div
            class="linear-gradient"
            style="
              background: linear-gradient(
                to right,
                rgba(126, 86, 120, 0),
                rgb(230, 195, 161),
                rgba(126, 86, 120, 0)
              );
            "
          ></div>
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
            
              <div class="wrapper">
                <div class="content">
                  <p class="vote-emoji large">{{ v.name=='big'?'🌹':v.name=='small'?'💐':v.name=='one'?'🎆':'🎈' }}</p>
                  <p class="name-text large">{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div
              class="item"
              @click="shopping ? (shopping = false) : (shopping = true)"
            >
              <van-icon name="cart-o" class="jixuanico" />
            
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text" style="margin-right: 6px;">{{ $t("reservation.available_balance") }}:</span>
            <span class="text num">{{ this.userInfo.money }}</span>
           
          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="bet-number">{{ convertedShopchoose  }}</div>
            <van-icon
              name="arrow-down"
              :class="{ up: !shopping, down: shopping }"
              @click="shopping ? (shopping = false) : (shopping = true)"
            />
          </div>
          <div class="item">
            <span class="label">{{ $t("reservation.per_price") }}</span>
            <div class="amount-wrapper">
              <van-field
                v-model="money"
                type="digit"
                :placeholder="$t('reservation.price_place')"
              />
              
            </div>
          </div>
          <!-- <div class="item">
            <div class="part">
              <span>{{ $t("reservation.total") }}</span>
              <span class="number">{{ this.formData.length }}</span>
              <span>{{ $t("reservation.note") }}</span>
            </div>
            <div class="part">
              <span>{{ $t("reservation.total") }}</span>
              <span class="number">{{
                this.formData.length * this.money
              }}</span>
              <span>{{ $t("reservation.unit") }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <!-- <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div> -->
          <ui class="list">
            <li
              v-for="(v, key) in formData"
              :key="key"
              class="lise-item van-hairline--bottom"
            >
              <div class="main">
                <p class="bet-name">{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon}}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money
                  }}{{ $t("reservation.unit") }}={{ money
                  }}{{ $t("reservation.ge") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button
              class="item cancel-btn"
              type="default"
              @click="allClear()"
              >{{ $t("reservation.clear_order") }}</van-button
            >
            <van-button class="item sub-btn" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">
                {{ $t("reservation.win_num") }}
              </div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
            
                  <span class="ballBox">{{ v.opencode[0] }}</span>
                  <span class="ballBox">{{ v.opencode[1] }}</span>
                  <span class="ballBox" style="margin-right: 20px;">{{ v.opencode[2] }}</span>
              
            
                  <span class="res-des ">{{
                    v.opencode[0] + v.opencode[1] + v.opencode[2]
                  }}</span>
                  <span
                    class=" middle"
                    >{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? rose :lily }}</span
                  >
                  <span class=" middle">{{
                    (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                      ? balloon
                      : fireworks
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
 
    </div>
    <van-popup v-model="showModel" round :style="{ width: '70%' }" class="task-picker">
      <div class="task-picker__header">Select Round</div>
      <div class="task-picker__list">
        <div
          class="task-picker__item"
          v-for="(i, index) in taskList"
          :key="index"
          :class="{ active: !i.placeholder && currentRound == (index + 1), disabled: i.placeholder }"
          @click="i.placeholder ? null : selectTask(i.id, i.key, index)"
        >
          <span class="task-picker__label">{{ i.label }}</span>
          <span v-if="i.placeholder" class="task-picker__hint">(unavailable)</span>
          <van-icon name="success" v-else-if="currentRound == (index + 1)" color="#cc2996" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks:"",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      currentRound: 1,
      unlockedThrough: 1,
      roundLocked: true,
      roundPoll: null,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')
      
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    applyServerRound(info) {
      if (!info) return;
      var round = parseInt(info.certify_round, 10);
      if (!(round >= 1 && round <= 3)) return;
      var prev = this.currentRound;
      this.currentRound = round;
      this.unlockedThrough = parseInt(info.unlocked_through, 10) || round;
      this.roundLocked = Number(info.round_locked) !== 0;
      var slot = this.taskList[round - 1];
      if (slot && slot.id) {
        this.ids = slot.id;
        this.keys = slot.key;
      }
      try {
        localStorage.setItem("selected_task_id", String(this.ids));
        localStorage.setItem("selected_task_key", String(this.keys));
        localStorage.setItem("selected_task_round", String(round));
      } catch (e) { /* noop */ }
      if (prev && prev !== round) {
        this.getLotteryInfo();
        this.getLotteryList();
      }
    },
    startRoundPoll() {
      var self = this;
      if (this.roundPoll) clearInterval(this.roundPoll);
      this.roundPoll = setInterval(function () {
        self.getUserInfo();
      }, 1500);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.applyServerRound(res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id:this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("lottery_peilv_list:",this.lottery_peilv_list);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          // normalize opencode of each history row into numeric array
          var rows = res.data || [];
          for (var i = 0; i < rows.length; i++) {
            var oc = rows[i].opencode;
            if (typeof oc === 'string') { oc = oc.split(','); }
            rows[i].opencode = (oc || []).map(function(x){ return parseInt(x, 10) || 0; });
          }
          this.lottery_list = rows;
          console.log("lottery_list:");
          console.log(res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitemData = res.data;
        console.log(this.gameitemData,'gameitemData')
      })
    },
    tabList(id,key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    },
    selectTask(id, key, index) {
      var round = (index || 0) + 1;
      if (this.roundLocked) {
        this.$toast("Your round is set by admin");
        this.showModel = false;
        return;
      }
      if (round > this.unlockedThrough) {
        return;
      }
      try {
        localStorage.setItem('selected_task_id', String(id));
        localStorage.setItem('selected_task_key', String(key));
      } catch (e) { /* noop */ }
      this.showModel = false;
      location.reload();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
           console.log(this.lottery,'qweqweqw')
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }

          // normalize opencode into a numeric 3-element array for display
          var _oc = res.data.opencode;
          if (typeof _oc === 'string') { _oc = _oc.split(','); }
          _oc = (_oc || []).map(function(x){ return parseInt(x, 10) || 0; });
          while (_oc.length < 3) { _oc.push(0); }
          this.lottery.opencode = _oc;
          var computedSum = _oc[0] + _oc[1] + _oc[2];
          this.sum = isNaN(computedSum) ? 0 : computedSum;
             console.log(this.sum,'sum')
          this.applyLotteryLabels();
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.rose;
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = this.lily;
          }
          if (this.sum % 2 === 0) {
            this.double = this.balloon;
          } else {
            this.double = this.fireworks;
            
         
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        console.log(this.lottery,9900)
      });
    },
  },
  created() {
    var savedId = null, savedKey = null;
    try {
      savedId = localStorage.getItem('selected_task_id');
      savedKey = localStorage.getItem('selected_task_key');
    } catch (e) { /* noop */ }
    if (savedId) this.ids = isNaN(parseInt(savedId, 10)) ? savedId : parseInt(savedId, 10);
    if (savedKey) this.keys = isNaN(parseInt(savedKey, 10)) ? savedKey : parseInt(savedKey, 10);

    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
      this.startRoundPoll();
    }
    this.applyLotteryLabels();

  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    taskTitle() {
      // KissMora: surfaces "Certify" as the page title (renamed from Lottery).
      return 'Certify';
    },
    userAvatar() {
      return (this.userInfo && this.userInfo.header_img) || '/img/mine/avatar.png';
    },
    lastCompleted() {
      // Prefer the latest history row; fall back to the lottery.opencode if sum > 0
      var list = Array.isArray(this.lottery_list) ? this.lottery_list : [];
      if (list.length && list[0] && Array.isArray(list[0].opencode)) {
        var oc = list[0].opencode;
        var s = (oc[0]||0) + (oc[1]||0) + (oc[2]||0);
        if (s > 0) {
          return { expect: list[0].expect, opencode: oc, sum: s };
        }
      }
      if (this.lottery && Array.isArray(this.lottery.opencode)) {
        var oc2 = this.lottery.opencode;
        var s2 = (oc2[0]||0) + (oc2[1]||0) + (oc2[2]||0);
        if (s2 > 0) {
          return { expect: this.lottery.now_expect, opencode: oc2, sum: s2 };
        }
      }
      return null;
    },
    hasResult() {
      return !!this.lastCompleted;
    },
    displayExpect() {
      return this.hasResult ? this.lastCompleted.expect : (this.lottery && this.lottery.now_expect) || '';
    },
    displaySum() {
      return this.hasResult ? this.lastCompleted.sum : 0;
    },
    displaySize() {
      if (!this.hasResult) return '';
      var s = this.lastCompleted.sum;
      if (s >= 11 && s <= 18) return this.rose;
      if (s >= 3 && s <= 10) return this.lily;
      return '';
    },
    displayDouble() {
      if (!this.hasResult) return '';
      return (this.lastCompleted.sum % 2 === 0) ? this.balloon : this.fireworks;
    },
    taskList() {
      var items = (this.gameitemData || []).slice(0, 3);
      var fallback = items[0] || { id: this.ids, key: this.keys };
      var out = [];
      for (var i = 0; i < 3; i++) {
        var unlocked = i < this.unlockedThrough;
        if (items[i] && unlocked) {
          out.push({ id: items[i].id, key: items[i].key, label: 'Round ' + (i + 1), placeholder: false });
        } else if (unlocked) {
          out.push({ id: fallback.id, key: fallback.key, label: 'Round ' + (i + 1), placeholder: false });
        } else {
          out.push({ id: null, key: null, label: 'Round ' + (i + 1), placeholder: true });
        }
      }
      return out;
    }
  },
  destroyed() {
    clearInterval(time);
    if (this.roundPoll) clearInterval(this.roundPoll);
  },
};
</script>

<style lang="less" scoped>
/* ============================================================
   KissMora Lottery — premium redesign
   (template & script unchanged; this style block replaces the old one)
   ============================================================ */

.lottery {
  min-height: 100vh;
  background:
    radial-gradient(900px 400px at -10% 0%, rgba(255,77,141,.12), transparent 60%),
    radial-gradient(800px 400px at 110% 10%, rgba(160,32,240,.12), transparent 60%),
    linear-gradient(180deg, #fff9fb 0%, #fff 40%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
  color: #1a1033;
  padding-bottom: calc(210px + env(safe-area-inset-bottom, 0));
}
.lottery * { box-sizing: border-box; }

/* Top nav */
::v-deep .van-nav-bar {
  background: linear-gradient(90deg, #ff4d8d 0%, #a020f0 100%);
  box-shadow: 0 6px 20px rgba(160,32,240,.25);
  height: 52px;
  line-height: 52px;
}
::v-deep .van-nav-bar__title {
  padding-left: 48px; /* room for notification bell */
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 800;
  letter-spacing: -.01em;
  max-width: none;
}
::v-deep .van-nav-bar::after { display: none; }
::v-deep .van-nav-bar__right {
  padding-right: 4px;
  min-width: 44px;
}

.task-switcher-btn {
  width: 38px; height: 38px; border-radius: 12px;
  background: rgba(255,255,255,.2);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: background .2s, transform .15s;
  backdrop-filter: blur(8px);
}
.task-switcher-btn:hover { background: rgba(255,255,255,.32); transform: translateY(-1px); }
.task-switcher-btn ::v-deep .van-icon { font-size: 20px; }

/* Record hero */
.record {
  margin: 14px 14px 0;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  border-radius: 22px;
  padding: 18px;
  color: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 14px 36px rgba(74,26,110,.25);
}
.record::before {
  content: ""; position: absolute; inset: 0;
  background:
    radial-gradient(circle at 15% 20%, rgba(255,77,141,.4), transparent 55%),
    radial-gradient(circle at 90% 80%, rgba(160,32,240,.35), transparent 55%);
  pointer-events: none;
}
.record .period {
  position: relative;
  display: flex; align-items: center; gap: 14px;
  margin-bottom: 14px;
}
.record .cover {
  width: 54px !important; height: 54px !important;
  border-radius: 50% !important;
  border: 2px solid rgba(255,255,255,.25);
  box-shadow: 0 4px 14px rgba(0,0,0,.3);
  flex-shrink: 0;
  overflow: hidden;
}
.record .cover ::v-deep img { width: 100%; height: 100%; object-fit: cover; }
.record .period-number {
  flex: 1;
  font-size: 14px; font-weight: 700;
  opacity: .9;
  line-height: 1.25;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.record .next-number { position: relative; font-weight: 800; }
.record .next-number ::v-deep .van-count-down {
  color: #ffd3e4;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: .5px;
  text-shadow: 0 0 18px rgba(255,77,141,.6);
}
.record .linear-gradient { display: none; }

/* Result box */
.result-box {
  position: relative;
  background: rgba(255,255,255,.98);
  border-radius: 16px;
  padding: 12px 16px;
  display: flex; align-items: center; gap: 14px;
  color: #1a1033;
  box-shadow: 0 8px 20px rgba(0,0,0,.18);
}
.result-box__label { flex: 1; min-width: 0; }
.result-box__expect {
  font-size: 14px; font-weight: 800; letter-spacing: -.01em;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.result-box__heading {
  font-size: 11px; color: #8d7fa6; margin-top: 2px;
  letter-spacing: .05em; text-transform: uppercase;
}
.result-box .resBox {
  display: flex; align-items: center; gap: 10px;
}
.result-box .resItem {
  width: 42px; height: 42px; border-radius: 50%;
  background: linear-gradient(135deg, #ff4d8d, #a020f0);
  color: #fff; font-weight: 800; font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 6px 14px rgba(255,77,141,.4);
  flex-shrink: 0;
}
.result-box .pills {
  display: flex; flex-direction: column; gap: 6px;
}
.result-box .ressquareBox {
  min-width: 80px; padding: 6px 14px; border-radius: 999px;
  background: linear-gradient(90deg, #ff4d8d, #a020f0);
  color: #fff; font-size: 12px; font-weight: 700;
  text-align: center;
  box-shadow: 0 4px 10px rgba(255,77,141,.25);
}
.result-box .ressquareBox.empty {
  background: #faf3f8; color: #8d7fa6;
  box-shadow: none;
}
.result-box__toggle {
  font-size: 20px !important; color: #a020f0;
  cursor: pointer; transition: transform .25s;
  flex-shrink: 0;
}
.result-box__toggle.up   { transform: rotate(180deg); }
.result-box__toggle.down { transform: rotate(0deg); }

/* Gift cards */
.wrapper { position: relative; }
.options-bar { padding: 18px 14px 0; }
.options-bar .game .linear-gradient { display: none; }
.sumValueTwoSides {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.rectangle.large {
  position: relative;
  background: linear-gradient(135deg, #fff9fb 0%, #fde5ef 100%);
  border-radius: 20px;
  padding: 22px 16px;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(255,77,141,.10), inset 0 1px 0 rgba(255,255,255,.7);
  border: 1.5px solid rgba(255,77,141,.22);
  transition: transform .2s, box-shadow .25s, border-color .2s, background .25s;
  overflow: hidden;
  min-height: 110px;
  display: flex; align-items: center;
}
.rectangle.large::before {
  content: ""; position: absolute; top: -40%; right: -20%;
  width: 60%; height: 60%; border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,.55), transparent 70%);
  pointer-events: none;
}
.rectangle.large::after {
  content: ""; position: absolute; inset: 0;
  background: radial-gradient(circle at 80% 120%, rgba(160,32,240,.15), transparent 60%);
  opacity: 0; transition: opacity .25s;
  pointer-events: none;
}
/* Per-card pastel accents so the 4 cards read distinctly, not all plain white */
.sumValueTwoSides .rectangle.large:nth-child(1) { background: linear-gradient(135deg, #fff9fb 0%, #ffd7e3 100%); }
.sumValueTwoSides .rectangle.large:nth-child(2) { background: linear-gradient(135deg, #fff9fb 0%, #ffe1d8 100%); }
.sumValueTwoSides .rectangle.large:nth-child(3) { background: linear-gradient(135deg, #fff9fb 0%, #e8d7ff 100%); }
.sumValueTwoSides .rectangle.large:nth-child(4) { background: linear-gradient(135deg, #fff9fb 0%, #d9e6ff 100%); }

.rectangle.large:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 34px rgba(255,77,141,.22), inset 0 1px 0 rgba(255,255,255,.7);
  border-color: rgba(255,77,141,.5);
}
.rectangle.large.active {
  border-color: transparent;
  background: linear-gradient(135deg, #ff4d8d 0%, #a020f0 100%) !important;
  box-shadow: 0 0 0 3px rgba(255,77,141,.3), 0 20px 40px rgba(160,32,240,.4);
  transform: translateY(-3px);
}
.rectangle.large.active::after { opacity: 1; }
.rectangle .wrapper { width: 100%; position: relative; }
.rectangle .content {
  display: flex; align-items: center; gap: 14px;
  position: relative;
}
.vote-emoji.large {
  font-size: 34px;
  margin: 0;
  line-height: 1;
  flex-shrink: 0;
  transition: transform .25s cubic-bezier(.2,.9,.3,1.3);
  filter: drop-shadow(0 4px 10px rgba(255,77,141,.3));
}
.rectangle.large.active .vote-emoji.large {
  transform: scale(1.18) rotate(-6deg);
  filter: drop-shadow(0 6px 14px rgba(0,0,0,.3));
}
.name-text.large {
  font-size: 16px;
  font-weight: 700;
  color: #1a1033;
  margin: 0;
  letter-spacing: -.01em;
  transition: color .2s;
}
.rectangle.large.active .name-text.large {
  color: #fff;
  -webkit-text-fill-color: #fff;
  text-shadow: 0 2px 8px rgba(0,0,0,.2);
}

/* Bottom fixed bar */
.bottom-bar {
  position: fixed;
  left: 0; right: 0;
  bottom: calc(70px + env(safe-area-inset-bottom, 0));
  z-index: 46;
  padding: 0 14px 0 72px; /* left inset clears support FAB */
}
@media (min-width: 720px) {
  .bottom-bar { bottom: 24px; }
}
.bottom-bar .bar {
  max-width: 620px; margin: 0 auto;
  background: rgba(255,255,255,.95);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(26,16,51,.06);
  border-radius: 20px;
  box-shadow: 0 14px 36px rgba(26,16,51,.14);
  padding: 10px 10px 10px 14px;
  display: flex; align-items: center; gap: 10px;
}
.bottom-bar .left { display: flex; align-items: center; }
.bottom-bar .left .item {
  width: 40px; height: 40px; border-radius: 12px;
  background: linear-gradient(135deg, rgba(255,77,141,.12), rgba(160,32,240,.12));
  border: 1px solid rgba(255,77,141,.2);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: background .2s, transform .15s, border-color .2s;
}
.bottom-bar .left .item:hover {
  background: linear-gradient(135deg, rgba(255,77,141,.2), rgba(160,32,240,.2));
  border-color: #ff4d8d;
  transform: translateY(-1px);
}
.bottom-bar .jixuanico { font-size: 22px !important; color: #ff4d8d; }
.bottom-bar .line {
  width: 1px; height: 24px; background: rgba(26,16,51,.08); margin: 0 8px;
}
.bottom-bar .mid {
  flex: 1; min-width: 0;
  display: flex; align-items: baseline; gap: 4px;
  overflow: hidden;
}
.bottom-bar .mid .text {
  font-size: 12px; color: #6b5c85; font-weight: 600;
  white-space: nowrap;
}
.bottom-bar .mid .num {
  font-size: 18px; font-weight: 800; letter-spacing: -.01em;
  background: linear-gradient(90deg, #ff4d8d, #a020f0);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.bottom-bar .right {
  flex-shrink: 0;
  padding: 11px 18px;
  min-width: 0;
  max-width: 46%;
  overflow: hidden;
  text-overflow: ellipsis;
  background: linear-gradient(90deg, #ff4d8d, #a020f0);
  color: #fff;
  border-radius: 999px;
  font-size: 14px; font-weight: 800; letter-spacing: .01em;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(255,77,141,.35);
  transition: transform .15s, box-shadow .2s;
  white-space: nowrap;
}
.bottom-bar .right:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(255,77,141,.5); }
.bottom-bar .right:active { transform: translateY(0); }

/* Expanded drawer above bar */
.bottom-bar .wrapper {
  max-width: 620px; margin: 0 auto;
  background: rgba(255,255,255,.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(26,16,51,.06);
  border-radius: 20px;
  box-shadow: 0 14px 36px rgba(26,16,51,.12);
  padding: 0 16px;
  margin-bottom: 10px;
  max-height: 0; overflow: hidden;
  opacity: 0;
  transition: max-height .3s ease, opacity .25s ease, padding .3s ease;
}
.bottom-bar .wrapper.active {
  max-height: 260px;
  opacity: 1;
  padding: 14px 16px;
}
.bottom-bar .wrapper .item {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(26,16,51,.05);
}
.bottom-bar .wrapper .item:last-child { border-bottom: none; }
.bottom-bar .wrapper .label {
  font-size: 13px; color: #6b5c85; font-weight: 600;
  flex-shrink: 0;
}
.bottom-bar .wrapper .bet-number {
  flex: 1; font-size: 13px; color: #1a1033; font-weight: 700;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.bottom-bar .wrapper .amount-wrapper { flex: 1; }
.bottom-bar .wrapper ::v-deep .van-field {
  background: #fff9fb;
  border-radius: 10px;
  padding: 4px 12px;
}
.bottom-bar .wrapper ::v-deep .van-field__control {
  font-size: 14px;
  color: #1a1033;
  font-weight: 600;
}

/* Round picker */
.task-picker {
  background: #fff;
  border-radius: 22px !important;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(0,0,0,.3);
}
.task-picker__header {
  padding: 18px 20px 14px;
  text-align: center;
  font-size: 17px; font-weight: 800;
  background: linear-gradient(90deg, #ff4d8d, #a020f0);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
  border-bottom: 1px solid rgba(26,16,51,.06);
}
.task-picker__list { padding: 8px; max-height: 60vh; overflow-y: auto; }
.task-picker__item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px; border-radius: 12px; cursor: pointer;
  font-size: 14px; font-weight: 600; color: #1a1033;
  transition: background .15s;
  margin-bottom: 4px;
}
.task-picker__item:hover { background: #fff9fb; }
.task-picker__item.active {
  background: linear-gradient(90deg, rgba(255,77,141,.1), rgba(160,32,240,.1));
  color: #ff4d8d;
}
.task-picker__item.disabled {
  color: #b8a9c9; cursor: not-allowed; pointer-events: none;
}
.task-picker__hint { font-size: 11px; color: #b8a9c9; }

/* Confirm order modal */
::v-deep .van-popup { border-radius: 20px; }
.confirm-order-modal {
  width: 88vw; max-width: 440px;
  padding: 20px;
  background: #fff;
}
.confirm-order-modal .list {
  list-style: none; padding: 0; margin: 0 0 14px;
  display: flex; flex-direction: column; gap: 8px;
}
.confirm-order-modal .lise-item {
  display: flex; align-items: center; justify-content: space-between;
  background: #fff9fb;
  border-radius: 14px;
  padding: 12px 14px;
}
.confirm-order-modal .lise-item .bet-name {
  font-size: 15px; font-weight: 700; margin: 0 0 2px; color: #1a1033;
}
.confirm-order-modal .lise-item .detail-text {
  font-size: 12px; color: #6b5c85; margin: 0;
}
.confirm-order-modal .lise-item .van-icon {
  font-size: 22px; color: #b8a9c9; cursor: pointer;
  transition: color .15s;
}
.confirm-order-modal .lise-item .van-icon:hover { color: #ff4d8d; }
.confirm-order-modal .sub-bar {
  display: flex; gap: 10px;
}
.confirm-order-modal .sub-bar .item {
  flex: 1;
  height: 44px !important;
  border-radius: 12px !important;
  font-weight: 700;
  font-size: 14px;
  border: none !important;
}
.confirm-order-modal .cancel-btn {
  background: linear-gradient(135deg, rgba(255,77,141,.08), rgba(160,32,240,.08)) !important;
  color: #a020f0 !important;
  border: 1.5px solid rgba(255,77,141,.3) !important;
  font-weight: 700;
}
.confirm-order-modal .cancel-btn:hover {
  background: linear-gradient(135deg, rgba(255,77,141,.15), rgba(160,32,240,.15)) !important;
  border-color: #ff4d8d !important;
}
.confirm-order-modal .sub-btn {
  background: linear-gradient(90deg, #ff4d8d, #a020f0) !important;
  color: #fff !important;
  box-shadow: 0 8px 20px rgba(255,77,141,.3);
}

/* History popup */
::v-deep .van-popup[position="top"] {
  border-radius: 0 0 24px 24px;
  background: #fff;
}
.history_popup { display: none; }
.van-popup .wrapper { padding: 16px; }
.van-popup .wrapper .item {
  display: flex; align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(26,16,51,.06);
  font-size: 13px;
}
.van-popup .wrapper .item .left {
  flex: 1;
  font-weight: 600; color: #4a3d66;
}
.van-popup .wrapper .item .right {
  flex: 2;
  display: flex; align-items: center;
}
.font-weight { font-weight: 700; color: #1a1033 !important; }
.kuaisan-ball { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
.ballBox {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #ff4d8d, #a020f0);
  color: #fff; font-size: 11px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.res-des, .middle {
  font-size: 11px; color: #6b5c85; font-weight: 600;
  padding: 2px 6px;
  background: #fff9fb;
  border-radius: 6px;
}

/* ===== Responsive — Tablet ===== */
@media (min-width: 720px) {
  .lottery { padding-bottom: 120px; }

  /* Center everything nicely and give breathing room */
  .record { margin: 24px auto 0; max-width: 960px; padding: 24px 28px; border-radius: 26px; }
  .record .period { margin-bottom: 18px; }
  .record .cover { width: 64px !important; height: 64px !important; }
  .record .period-number { font-size: 15px; }
  .record .next-number ::v-deep .van-count-down {
    font-size: 26px; letter-spacing: 1px;
  }
  .result-box { padding: 16px 22px; border-radius: 18px; }
  .result-box__expect { font-size: 15px; }
  .result-box .resItem { width: 52px; height: 52px; font-size: 22px; }
  .result-box .ressquareBox { min-width: 100px; padding: 8px 18px; font-size: 13px; }

  .options-bar { padding: 28px 28px 0; max-width: 960px; margin: 0 auto; }
  .sumValueTwoSides { grid-template-columns: repeat(4, 1fr); gap: 18px; }
  .rectangle.large {
    min-height: 150px; padding: 28px 22px; border-radius: 22px;
    flex-direction: column; text-align: center; justify-content: center;
  }
  .rectangle.large .content { flex-direction: column; align-items: center; gap: 14px; }
  .vote-emoji.large { font-size: 54px; }
  .name-text.large { font-size: 20px; }

  /* Floating bottom action bar — wider, richer */
  .bottom-bar { padding: 0 24px; bottom: 28px; }
  .bottom-bar .bar {
    max-width: 780px;
    padding: 14px 14px 14px 18px;
    border-radius: 24px;
    gap: 14px;
  }
  .bottom-bar .left .item { width: 48px; height: 48px; border-radius: 14px; }
  .bottom-bar .jixuanico { font-size: 26px !important; }
  .bottom-bar .mid .text { font-size: 14px; }
  .bottom-bar .mid .num { font-size: 22px; }
  .bottom-bar .right { padding: 13px 28px; font-size: 15px; }
  .bottom-bar .wrapper { max-width: 780px; padding: 0 18px; }
  .bottom-bar .wrapper.active { padding: 16px 18px; }
}

/* ===== Desktop — 2-column hero + 4-up gifts ===== */
@media (min-width: 1024px) {
  .lottery {
    display: flex; flex-direction: column;
  }

  /* Hero = horizontal layout with countdown + results side-by-side */
  .record {
    max-width: 1100px;
    display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 28px;
    align-items: center;
    padding: 28px 32px;
  }
  .record > .period { margin: 0; }
  .record > .linear-gradient { display: none; }
  .result-box {
    margin: 0;
    padding: 18px 26px;
  }

  /* Gift cards: full 4-up row with generous sizing */
  .options-bar { padding: 32px 32px 0; max-width: 1100px; }
  .sumValueTwoSides { grid-template-columns: repeat(4, 1fr); gap: 22px; }
  .rectangle.large { min-height: 170px; padding: 34px 24px; border-radius: 24px; }
  .vote-emoji.large { font-size: 64px; }
  .name-text.large { font-size: 22px; }

  /* Submit bar centered wider */
  .bottom-bar .bar { max-width: 900px; }
  .bottom-bar .wrapper { max-width: 900px; }
}

@media (min-width: 1280px) {
  .record { max-width: 1200px; }
  .options-bar { max-width: 1200px; }
}
@media (max-width: 380px) {
  .record { margin: 10px 10px 0; padding: 14px; border-radius: 18px; }
  .record .cover { width: 46px !important; height: 46px !important; }
  .record .period-number { font-size: 12px; }
  .record .next-number ::v-deep .van-count-down { font-size: 18px; }
  .result-box { padding: 10px 12px; gap: 10px; }
  .result-box .resItem { width: 36px; height: 36px; font-size: 15px; }
  .result-box .ressquareBox { min-width: 64px; padding: 5px 10px; font-size: 11px; }
  .options-bar { padding: 14px 10px 0; }
  .sumValueTwoSides { gap: 10px; }
  .rectangle.large { min-height: 94px; padding: 16px 12px; }
  .vote-emoji.large { font-size: 28px; }
  .name-text.large { font-size: 14px; }
  .bottom-bar { padding: 0 10px; }
  .bottom-bar .bar { padding: 8px 8px 8px 12px; }
  .bottom-bar .right { padding: 10px 18px; font-size: 13px; }
}
</style>
